<template>
  <div id="app">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <link href="https://use.typekit.net/suk3yiz.css"  rel='stylesheet' type='text/css'>
    <link href="https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap" rel="stylesheet">
    
      <router-view />
      <div style="display: none;" class="modal-custom" id="refresh_token_retry">
        <div class="loader-img-center">
          <i class="fa fa-spinner fa-spin"></i> Please wait while we refresh your session...
        </div>
      </div>

  </div>


</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from './store/store';

export default {
  name: 'App',

  created() {
      if(this.$store.state.user_accountid) {
      axios('/desktop/get-account-color-code-logo/' + this.$store.state.user_accountid,
      {
        method: 'GET',
      })
      .then(resp => {
        if(resp.data.buttonColorCode) {
          document.documentElement.style.setProperty('--main-bg-color', resp.data.buttonColorCode);
        }
        else {
          document.documentElement.style.setProperty('--main-bg-color', '#00ACEE');
        }
        if(resp.data.logoName) {
          Vue.prototype.$logoName = resp.data.logoName;
          Vue.prototype.$isBranding = 1;
        }
        else {
          Vue.prototype.$logoName = 'MM-logo.png';
          Vue.prototype.$isBranding = '';
        }

      })
      .catch(() => {
      });
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue